import { render } from "./ValidatorChartSingle.vue?vue&type=template&id=145635ec&scoped=true"
import script from "./ValidatorChartSingle.vue?vue&type=script&lang=js"
export * from "./ValidatorChartSingle.vue?vue&type=script&lang=js"

import "./ValidatorChartSingle.vue?vue&type=style&index=0&id=145635ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145635ec"]])

export default __exports__